
define('jsx!components/lists/large-images',['jquery', 'underscore', 'react', 'lib', 'classnames', 'jsx!components/react-if/main', 'jsx!components/react-ad/main'], function($, _, React, lib, classNames, If, Ad) {
    'use strict';

    var PureRenderMixin = React.addons.PureRenderMixin;
    var LargeImages = React.createClass({displayName: "LargeImages",
        mixins: [PureRenderMixin],
        getDefaultProps: function() {
            return {
                url: '/articles',
                query: {},
                limit: 3,
                offset: 0,
                header: true,
                ads: null,
            };
        },
        getInitialState: function() {
            return {
                list: [],
            };
        },
        componentDidMount: function() {
            this.updateList();
        },
        updateList: function() {
            var limit = this.props.limit;
            if(lib.getArticleId()) {
                limit += 1;
            }

            var query = this.props.query;
            if (this.props.author) {
                query.author = this.props.author;
            }
            $.getJSON(lib.getApiUrl(this.props.url), _.extend({limit: limit, offset: this.props.offset}, query)).done(_.bind(function(list) {
                this.setState({
                    list: list
                });
            }, this));
        },
        filterList: function(list) {
            return _.filter(list, function(article) {
                return (article.id !== lib.getArticleId());
            }).slice(0, this.props.limit);
        },
        getAuthorInfo: function(article) {
            if (article.authorInfo) {
                if (article.authorInfo.section) {
                    return React.createElement("div", {className: 'related-author-info related-author-info--compact related-author-info--' + article.authorInfo.section}, 
                        React.createElement("p", {className: "related-author-info__description"}, article.authorInfo.section)
                    );
                } else {
                    return React.createElement("div", {className: "related-author-info"}, 
                        React.createElement("img", {className: "related-author-info__image", src: article.authorInfo.image}), 
                        article.authorInfo.e24kommentarer ? React.createElement(Logo, {style: {width: 25, left: 2, bottom: 0, position: 'absolute'}}) : null, 
                        React.createElement("div", {className: "related-author-info__container"}, 
                            React.createElement("p", {className: "related-author-info__description"}, "kommentar"), 
                            React.createElement("p", {className: "related-author-info__name"}, article.authorInfo.name)
                        )
                    );
                }
            }
        },
        render: function() {
            return React.createElement("div", {className: "articles-widget articles-list large-article-image-list", "data-art-list": this.props.listname || 'sharedarticlelist'}, 
                React.createElement(If, {condition: this.props.header}, 
                    React.createElement("header", {className: "e24-section-header"}, 
                        React.createElement("h6", null, "Les også")
                    )
                ), 
                React.createElement("ul", null, 
                    _.map(this.filterList(this.state.list), _.bind(function(article, i) {
                        var className = classNames(!article.authorInfo ? article.articleType : '', {
                            first: i%3 === 0,
                        });
                        return React.createElement("li", {key: article.id, className: className}, 
                            React.createElement("a", {href: article.url || lib.getBasePath('/article/' + article.id), "data-artid": article.id}, 
                                React.createElement("div", {className: "image-container"}, 
                                    article.paywall ? (
                                        React.createElement("div", {className: "e24-sprite-container"}, 
                                            React.createElement("span", {className: "e24-icon-e24pluss"})
                                        )
                                    ) : '', 
                                    React.createElement("img", {className: "image-container-img", src: article.thumbnail}), 
                                    this.getAuthorInfo(article)
                                ), 
                                article.paywall ? (
                                    React.createElement("h6", {className: "e24-plus-subscription-required"}, "For abonnenter")
                                ) : '', 
                                React.createElement("h4", null, article.authorInfo && article.presentationTitle ? article.presentationTitle : article.title)
                            ), 
                             this.props.ads && this.props.ads.row === (i+1) && React.createElement(Ad, {name: this.props.ads.placement})
                        );
                    },this))
                )
            );
        }
    });

    return function renderComponent(element, config) {
        if (!element) {
            return;
        }

        config = config || {};
        config.author = element.getAttribute('data-author');
        config.listname = element.getAttribute('data-listname');

        React.render(React.createElement(LargeImages, React.__spread({},  config)), element);
    };
});

